import request from '@/utils/request'

export const getDashboard = params => request({ url: '/dkmall/dashboard', method: 'get', params })
export const getBestsellers = params => request({ url: '/dkmall/dashboard/bestsellers', method: 'get', params })
